// Copied from advisor-3.0/src/components/Footer/FooterModalPopup.js
import { ReactNode } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface FooterModalPopupProps {
  open: boolean;
  onDialogClose: () => void;
  component: ReactNode;
  isInsideModal?: boolean;
}

export default function FooterModalPopup({ open, onDialogClose, component, isInsideModal }: FooterModalPopupProps) {
  return (
    <Dialog open={open} onClose={onDialogClose} scroll="body" maxWidth="md">
      <DialogContent className={`${isInsideModal ? 'grey-h5' : ''} product-info-dialog-content-footer`}>
        <IconButton className="product-info-close-button" aria-label="close" onClick={onDialogClose}>
          <CloseIcon />
        </IconButton>
        {component}
      </DialogContent>
    </Dialog>
  );
}
